// import moment from 'moment'

const state = {
    id: 0,
    url: '',
    description: '',
    title: '',
    grade: [],
    interest: 'ALL',
    mapel: '',
    thumbnail:'',
    source: '',
    duration: '',
    editContent: []
  }
  
  const mutations = {
    video_reset: function(state) {
      state.id = 0
      state.url = ''
      state.description = ''
      state.title = ''
      state.grade = []
      state.interest = 'ALL'
      state.mapel = ''
      state.thumnail = ''
      state.source = ''
      state.duration = ''
    },
    setEditDataContent: function(state, data){
      state.editContent = data
    }
  }
  
  const getters = {
  //   openedAt: function(state) {
  //     var time = 0
  //     state.tryouts.forEach(function(tryout) {
  //       var tryoutStartTime = moment(tryout.start_date + ' ' + tryout.start_time, 'YYYY-MM-DD HH:mm').format('x')
  //       if (time == 0 || tryoutStartTime < time) time = Number(tryoutStartTime)
  //     })
  
  //     return time
  //   },
  //   closedAt: function(state) {
  //     var time = 0
  //     state.tryouts.forEach(function(tryout) {
  //       var tryoutEndTime = moment(tryout.end_date + ' ' + tryout.end_time, 'YYYY-MM-DD HH:mm').format('x')
  //       if (time == 0 || tryoutEndTime > time) time = Number(tryoutEndTime)
  //     })
  
  //     return time
  //   }
  }
  
  export default {state, mutations, getters}
  


// WEBPACK FOOTER //
// ./src/store/modules/content.js